import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import usePageSEO from "../hooks/usePageSEO";

export default function About() {

  usePageSEO({
    title: "About Page",
    description: "About description", 
    keywords: ["keyword 1" , "keyword 2"],
    ogTitle: "", 
    ogDescription: "", 
    ogImage: "", 
    ogUrl: "https://www.qubeartgallery.com/"
    })

  const cust_logos = {
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    dots: false,
        pauseOnHover: false,
        responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 3
        }
    }, {
        breakpoint: 520,
        settings: {
            slidesToShow: 2
        }
    }]

  };

   
    return (

      

      <div>
     

<section class="about-us">

<div class="container">
<div class="row">
<div class="col-md-6 about-bg">
<p><span>ABOUT US</span></p>
<h4>Qube Art Gallery</h4>
<p>QUBE Art Gallery is your one stop destination to all artwork supply related services such from Fine Art Printing to Art reproduction. We provide pigment based high quality printing on the best quality canvas and papers using our wide format inkjet printers. We have a huge collection of artworks and frames as well as the breadth and flexibility to fulfil the diverse needs and custom requests of our varied customers.</p>
<p>From humble beginnings in 2010, to our now extensive portfolio that boasts a diverse range of clientele ranging from hotel chains to popular retail stores, QUBE Art Gallery has embarked on a journey to imprint their mark in the art service industry.</p>
<p>Our team consists of talented and experienced professionals in the fields of Museum Quality Framing, Original Painting, Wall art and Giclee Art Production, striving to bring your artistic visions to life.</p>
</div>

<div class="col-md-6">
<img src="images/04.jpg" alt=""/> 
</div>


</div>
</div>
</section>

<section class="logo-slider">

         <div class="client-logos">

         <h2 class="slider-title">-TRUSTED BY-</h2>
         
         <div class="customer-logos">
         <Slider {...cust_logos}>
<div class="slide"><img src="images/logos/10.png" alt="" /></div>
<div class="slide"><img src="images/logos/17.png" alt="" /></div>
  <div class="slide"><img src="images/logos/2.png" alt="" /></div>
  <div class="slide"><img src="images/logos/3.png" alt="" /></div>
  <div class="slide"><img src="images/logos/4.png" alt="" /></div>
<div class="slide"><img src="images/logos/15.png" alt="" /></div>
<div class="slide"><img src="images/logos/5.png" alt="" /></div>
 <div class="slide"><img src="images/logos/11.png" alt="" /></div>
  
<div class="slide"><img src="images/logos/16.png" alt="" /></div>
  <div class="slide"><img src="images/logos/6.png" alt="" /></div>
  <div class="slide"><img src="images/logos/7.png" alt="" /></div>
  
  <div class="slide"><img src="images/logos/9.png" alt="" /></div>
<div class="slide"><img src="images/logos/8.png" alt="" /></div>
 <div class="slide"><img src="images/logos/12.png" alt="" /></div>
  <div class="slide"><img src="images/logos/13.png" alt="" /></div>
<div class="slide"><img src="images/logos/18.png" alt="" /></div>
  <div class="slide"><img src="images/logos/14.png" alt="" /></div>
  
  <div class="slide"><img src="images/logos/19.png" alt="" /></div>
  <div class="slide"><img src="images/logos/20.png" alt="" /></div>
<div class="slide"><img src="images/logos/21.png" alt="" /></div>
<div class="slide"><img src="images/logos/23.png" alt="" /></div>
<div class="slide"><img src="images/logos/24.png" alt="" /></div>
<div class="slide"><img src="images/logos/jotun.png" alt="" /></div>
</Slider>
</div>


         </div>

</section>
</div>

    )
  }

